/**
 * @desc sku报价列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierQuotation.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/page/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
